// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"3adf922a","511":"6ec15718","844":"28c9db64"}[chunkId] + ".chunk.js";
};